export default {
  methods: {
    buildExportQuery() {
      return {
        billingPeriod: this.$store.state.shared.billingPeriod,
        billingStatus: this.$store.state.shared.billingStatus,
        projectId: this.$store.state.shared.projectId,
        showClosed: this.$store.state.shared.showClosed,
        siteId: this.$store.state.shared.siteId,
        userId: this.$store.state.shared.selectedUserId,
        dateRangeStart: this.$store.state.shared.dateRangeStart,
        dateRangeEnd: this.$store.state.shared.dateRangeEnd,
        filterCol: this.$store.state.approvedBillLines.filterCol,
        filterBy: this.$store.state.approvedBillLines.filterBy,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: undefined,
          rowsPerPageItems: [10, 20, 40, 50],
          sortBy: null,
          totalItems: 0
        }
      }
    },

    buildQuery() {
      return {
        billingPeriod: this.$store.state.shared.billingPeriod,
        billingStatus: this.$store.state.shared.billingStatus,
        projectId: this.$store.state.shared.projectId,
        showClosed: this.$store.state.shared.showClosed,
        siteId: this.$store.state.shared.siteId,
        userId: this.$store.state.shared.selectedUserId,
        dateRangeStart: this.$store.state.shared.dateRangeStart,
        dateRangeEnd: this.$store.state.shared.dateRangeEnd,
        filterCol: this.$store.state.approvedBillLines.filterCol,
        filterBy: this.$store.state.approvedBillLines.filterBy,
      }
    }    
  }
}
